import React from 'react';
import { Element } from 'react-scroll';
import ContactOwnerModal, {
  ContactOwnerFormData,
} from 'src/components/ContactOwner/ContactOwnerModal';
import Report from 'src/components/Page/ReportPage';
import { OwnerAvatar } from 'src/components/Avatar';
import styles from './AboutFundraiser.scss';
import ClickableElement from 'src/components/ClickableElement';
import Svg from '@jg/svg';
import locationPin from '@jg/icons/lib/map-pin.svg';

interface Props {
  addCensure: () => void;
  clearRecaptcha: () => void;
  closeContactOwner: () => void;
  contactOwner: (
    data: { id: string; recaptcha: string; subject: string; message: string }
  ) => void;
  id: string;
  pageName: string;
  location?: string;
  isContactingOwnerWindowOpen: boolean;
  contactOwnerPageViewSection: string;
  contactOwnerPageSection: string;
  contactOwnerSubjectPlaceHolder?: string;
  contactOwnerMessagePlaceholder?: string;

  openContactOwner: (
    pageName: string,
    pageViewSection: string,
    pageSection: string
  ) => void;
  ownerBio?: string;
  ownerName: string;
  profileImage?: string;
  recaptcha: string;
  setRecaptcha: (response: string) => void;
  onMessageSent: () => void;
}

interface State {
  submissionError: boolean;
}

class AboutFundraiser extends React.Component<Props, State> {
  state = { submissionError: false };

  handleSubmit = async (data: ContactOwnerFormData) => {
    const { clearRecaptcha, contactOwner, id, onMessageSent } = this.props;

    if (this.state.submissionError) {
      this.setState({ submissionError: false });
    }

    try {
      await contactOwner({
        id,
        recaptcha: this.props.recaptcha,
        ...data,
      });

      clearRecaptcha();
      if (onMessageSent) {
        onMessageSent();
      }
    } catch (e) {
      this.setState({ submissionError: true });
    }
  };

  handleContactOwner = () => {
    this.props.openContactOwner(
      `${this.props.pageName}/contact`,
      'page view > footer',
      'page > footer'
    );
  };

  render() {
    const {
      addCensure,
      closeContactOwner,
      isContactingOwnerWindowOpen,
      contactOwnerPageViewSection,
      contactOwnerPageSection,
      contactOwnerSubjectPlaceHolder,
      contactOwnerMessagePlaceholder,
      location,
      ownerBio,
      ownerName,
      profileImage,
      recaptcha,
      setRecaptcha,
    } = this.props;

    return (
      <Element name="about-fundraiser" className={`${styles.container}`}>
        {isContactingOwnerWindowOpen && (
          <ContactOwnerModal
            closeContactOwner={closeContactOwner}
            onSubmit={this.handleSubmit}
            ownerName={ownerName}
            recaptcha={recaptcha}
            setRecaptcha={setRecaptcha}
            submissionError={this.state.submissionError}
            pageViewSection={contactOwnerPageViewSection}
            pageSection={contactOwnerPageSection}
            subjectPlaceHolder={contactOwnerSubjectPlaceHolder}
            messagePlaceholder={contactOwnerMessagePlaceholder}
          />
        )}
        <div>
          <h5 className="jg-h5 jg-space-mbmd@md jg-space-mbsm">
            About the fundraiser
          </h5>
          <div className={`jg-display-flex ${styles.content}`}>
            <div className={`${styles['avatar-container']}`}>
              <OwnerAvatar
                className="jg-space-mbsm"
                src={profileImage}
                alt={ownerName}
              />
            </div>
            <div>
              <h3 className="jg-h3 jg-display-i jg-space-mrmd">{ownerName}</h3>

              {location && (
                <div className="jg-display-i">
                  <span className="jg-relative">
                    <Svg
                      className={`jg-fill--nobel jg-icon--medium-small jg-display-i ${
                        styles['location-pin']
                      }`}
                      markup={locationPin}
                    />
                    <p className="jg-space-mlmd jg-color--nobel jg-display-i">
                      {location}
                    </p>
                  </span>
                </div>
              )}

              <p className="jg-text--large jg-space-mtsm@md">{ownerBio}</p>
              <div className="jg-space-mtsm">
                <ClickableElement
                  onClick={this.handleContactOwner}
                  className="jg-text--link jg-space-mrlg"
                  inline
                  analyticsOptions={{
                    event: 'link click',
                    subtype: 'button',
                    eventValue: 'Contact page owner',
                    pageSection: 'page > footer',
                  }}
                >{`Contact ${ownerName}`}</ClickableElement>
                <Report className="jg-text--link" addCensure={addCensure} />
              </div>
            </div>
          </div>
        </div>
      </Element>
    );
  }
}

export default AboutFundraiser;



// WEBPACK FOOTER //
// ./src/components/AboutFundraiser/AboutFundraiser.tsx